<div class="page-wrapper mb-4">
  <div class="card-container">
    <div class="container-img">
      <img class="copasaImg" src="../../../../../assets/images/copasa.png" />
    </div>
    <div class="error-title">Página não encontrada</div>
    <p class="error-message">
      A página que você tentou acessar não existe ou o endereço está incorreto.
    </p>
    <p class="error-message">
      Verifique se você acessou o link completo e correto enviado pela COPASA.
    </p>
    <ul class="link-list">
      <li class="link-item">
        <span class="icon-circle bg-info">
          <i class="pi pi-question icon-white"></i>
        </span>
        <div class="link-content">
          <span class="link-title">Ajuda</span>
          <p class="link-description">
            Os links válidos geralmente seguem o padrão:<br />
            <code>http://spia.sigoscopasa.com.br/#/portal/SPIA48647486xFE0C8D37D13C48B8AA43B42624EC160A</code>
          </p>
        </div>
      </li>
    </ul>
  </div>
</div>
<app-footer></app-footer>
